import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiError } from "./AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-primary">Private</p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl font-light">
            GentleGi<span className="italic text-primary">T</span>o
          </h1>
          <p className="mt-3 text-sm text-muted-foreground font-serif italic">
            Studio access only.
          </p>
        </div>

        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="bg-white/70 border border-border/60 rounded-3xl p-8 sm:p-10 space-y-6 backdrop-blur-sm"
        >
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
              Email
            </label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="quiet-input mt-2"
              placeholder="you@gentlegito.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
              Password
            </label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="quiet-input mt-2"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p
              data-testid="login-error"
              className="text-sm font-serif italic text-destructive"
            >
              {error}
            </p>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="w-full mt-4 px-8 py-4 rounded-full bg-primary text-primary-foreground text-sm tracking-wide hover:bg-primary/90 transition-all duration-300 disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="text-center mt-8 text-xs tracking-wide text-muted-foreground">
          ← <a href="/" className="editorial-link">Back to GentleGiTo</a>
        </p>
      </div>
    </div>
  );
}
